import { shrpaApi } from "./axios";
import { ContentSummaryData, ContentSummaryFullPayload, ContentSummaryPreview, ContentSummaryPreviewPayload, ContentSummaryProcessingPayload } from "@contracts/contentCalendar";

export default {
  async getAllSummariesFull(customerId: string, justValid = true): Promise<ContentSummaryFullPayload> {
    const uri = `/content-summary/${customerId}/full?justValid=${justValid}`;
    const { data } = await shrpaApi.get<ContentSummaryFullPayload>(uri);
    return data;
  },

  /** The usable content album for one context (ex. a Location's Google Place ID), or null when there isn't one. */
  async getSummaryPreviewByContext(customerId: string, contextId: string): Promise<ContentSummaryPreview | null> {
    const uri = `/content-summary/${customerId}/preview/by-context?contextId=${encodeURIComponent(contextId)}`;
    const { data } = await shrpaApi.get<ContentSummaryPreview | null>(uri);
    return data || null;
  },

  async getAllSummariesPreview(customerId: string, justValid = true, includeExamples = false): Promise<ContentSummaryPreviewPayload> {
    const uri = `/content-summary/${customerId}/preview?justValid=${justValid}&includeExamples=${includeExamples}`;
    const { data } = await shrpaApi.get<ContentSummaryPreviewPayload>(uri);
    return data;
  },

  async getProcessingSummaries(customerId: string): Promise<ContentSummaryProcessingPayload> {
    const uri = `/content-summary/${customerId}/processing`;
    const { data } = await shrpaApi.get<ContentSummaryProcessingPayload>(uri);
    return data;
  },

  async reprocess(customerId: string, contentSummaryId: string): Promise<ContentSummaryData> {
    const uri = `/content-summary/${customerId}/${contentSummaryId}/reprocess`;
    const { data } = await shrpaApi.post<ContentSummaryData>(uri);
    return data;
  },
};
